import { type AnyAction, type Dispatch, type Middleware, isRejected } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { ActionType } from 'enums/ActionType';

const END_OF_REJECTED_ACTION = '/rejected';

const errorHandlerMiddleware: Middleware = () => (dispatch: Dispatch<AnyAction>) => (action) => {
  const next = dispatch;

  if (isRejected(action)) {
    if (action.type !== `${ActionType.FetchDeploymentStatus}${END_OF_REJECTED_ACTION}`) {
      toast.error(action.error.message);
    }
  }

  next(action);
};

export default errorHandlerMiddleware;
